// extracted by mini-css-extract-plugin
export default {"ezosloader":"LoadingAnimation_ezosloader__a++hK","bounce":"LoadingAnimation_bounce__tq7+j"};